import { render } from "./project-list-modal.vue?vue&type=template&id=5f3ca344"
import script from "./project-list-modal.vue?vue&type=script&lang=js"
export * from "./project-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__